import { render, staticRenderFns } from "./EscalasComponent.vue?vue&type=template&id=60c877c9&"
import script from "./EscalasComponent.vue?vue&type=script&lang=js&"
export * from "./EscalasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports